import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
// import TranslateComponent from '../TranslateComponent';
import Header from './Header';
import Cloud from '../Cloud';
import CloudComponent from '../CloudComponent';
import appVersion from "../../version";

const Languages = ({ vist_id }) => {
  const [languageId, setLanguageId] = useState(null);
  const [botLanguageId, setBotLanguageId] = useState(null);
  const [language, setLanguage] = useState(null);
  const [showOkButton, setShowOkButton] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const app_ver = appVersion.app_ver;
  const date = appVersion.date;

  const helpOptions = [
    {
      id: "A",
      value: "Kn",
      label: "ಕನ್ನಡ",
      b_lang_id:"1"
    },
    {
      id: "B",
      value: "en",
      label: "English",
      b_lang_id:"2"
    },

    {
      id: "C",
      value: "Hi",
      label: "हिंदी",
      b_lang_id:"3"
    },
  ];

  const handleHelpLanguageClick = async (option, e) => {
    e.preventDefault();
    if (option.disabled) {
      return; // Ignore clicks on disabled options
    }
    setLanguageId(option.id);
    setBotLanguageId(option.id);
    setLanguage(option.value);
    setShowOkButton(true);
    setError("");
  };

  const handleOkClick = (e) => {
    e.preventDefault();
    if (languageId) {
      // Store the selected language in a cookie (expires in 7 days)
      Cookies.set('selectedLanguage', language, { expires: 7 });
      Cookies.set('botLanguageId', botLanguageId, { expires: 7 });
      navigate("/help", { replace: true , state: { vist_id: vist_id } });
      // Optionally, you can update any related state or navigate to a new route
      // For example, if you are using a context or a global state manager, update it here.
      // Or, if you have a translate component, you can pass the language selection as a prop.
      
      console.log(`Language ${language} saved in cookies.`);
    } else {
      setError("Please select an option before proceeding.");
      setShowOkButton(false);
    }
  };


  
  return (
    <div style={{ height: "100vh", width: "100vw", display:'flex', justifyContent:'center', alignItems:'center' }}>

      <Header/>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <div style={{ marginTop: "-120px" }}>
          <div style={{ display: "flex" }}>
            <h2 style={{ marginLeft: "12px", textAlign: "center" }}>
              Select the Language
            </h2>
          </div>
          <div className="options-container">
            {helpOptions.map((option) => (
              <button
                key={option.id}
                className={`option-buttons ${languageId === option.id ? "selected" : ""} ${option.disabled ? "disabled" : ""}`}
                style={{
                  opacity: option.disabled ? 0.5 : 1,
                  cursor: option.disabled ? "not-allowed" : "pointer",
                }}
                onClick={(e) => handleHelpLanguageClick(option, e)}
                disabled={option.disabled}
              >
                <div className="answer-container">
                  <div
                    className="option"
                    style={{
                      backgroundColor: languageId === option.id ? "#000" : "#fff",
                      color: languageId === option.id ? "#fff" : "#000",
                    }}
                  >
                    {option.id}
                  </div>
                  <div className="option-label" style={{ textAlign: "start" }}>
                    {option.label}
                  </div>
                </div>
                {languageId === option.id && (
                  <span className="checkmark">&#10003;</span>
                )}
              </button>
            ))}
            <div style={{ position: "fixed", bottom: "0", left: "0", zIndex: "0" }}>
              <CloudComponent />
            </div>
            <div style={{ position: "fixed", bottom: "0", right: "0", zIndex: "0" }}>
              <Cloud />
            </div>
            {error && <div className="error-message">{error}</div>}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          {showOkButton && (
            <button type="button" className="ok-btn" onClick={handleOkClick}>
              OK
            </button>
          )}
        </div>
        <p style={{ fontSize: "14px", position: "fixed", bottom: "0" }}>
          Version : {app_ver} | {date}
        </p>
      </div>
    </div>
  );
};

export default Languages;
